export interface PortalTenantRecord {
  id?: string;
  name?: string | null;
}

export interface PortalAccountRecord {
  id: string;
  name?: string | null;
  legacyCustomerId?: string | null;
  tenantCount?: number;
  tenants?: PortalTenantRecord[];
}

interface AccountListResponse {
  data?: PortalAccountRecord[];
}

export interface AccountTenantRecord {
  id: string;
  accountId: string;
  name: string;
  region?: string | null;
  status?: string | null;
}

interface TenantListResponseItem {
  id: string;
  accountId: string;
  name: string;
  region?: string | null;
  status?: string | null;
}

interface TenantListResponse {
  data?: TenantListResponseItem[];
}

async function fetchJSON<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Request failed: ${response.status}`);
  }
  return (await response.json()) as T;
}

export async function listAccounts(includeTenants = false): Promise<PortalAccountRecord[]> {
  const url = includeTenants ? '/api/v1/accounts?includeTenants=true' : '/api/v1/accounts';
  const payload = await fetchJSON<AccountListResponse>(url);
  return payload.data ?? [];
}

export async function listAccountTenants(accountId: string): Promise<AccountTenantRecord[]> {
  const payload = await fetchJSON<TenantListResponse>(`/api/v1/accounts/${encodeURIComponent(accountId)}/tenants`);
  const items = payload.data ?? [];
  return items.map(item => ({
    id: item.id,
    accountId: item.accountId,
    name: item.name,
    region: item.region ?? null,
    status: item.status ?? null
  }));
}

export async function setActiveAccount(accountId: string | null): Promise<void> {
  const payload = {
    items: [
      {
        key: 'context.activeAccountId',
        value: accountId,
        scope: 'USER'
      }
    ]
  };

  const response = await fetch('/api/v1/preferences:bulkSet', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Failed to update active account');
  }
}
